var _filter, _clipPath, _clipPath2, _clipPath3, _use, _use2, _use3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManukaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "117px",
    height: "36px",
    viewBox: "0 0 117 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.921569%,28.627451%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 11.992188 -0.0976562 C 12.121094 -0.0976562 12.253906 -0.0976562 12.382812 -0.0976562 C 12.625 0.195312 12.820312 0.523438 12.96875 0.878906 C 12.78125 1.15625 12.71875 1.484375 12.773438 1.859375 C 12.632812 1.179688 12.371094 0.527344 11.992188 -0.0976562 Z M 11.992188 -0.0976562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,3.529412%)",
      fillOpacity: 1
    },
    d: "M 95.648438 13.988281 C 95.777344 18.03125 95.90625 22.074219 96.039062 26.121094 C 95.980469 26.273438 95.886719 26.40625 95.746094 26.511719 C 95.648438 22.335938 95.613281 18.164062 95.648438 13.988281 Z M 95.648438 13.988281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.027451,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 117,
    height: 36
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 111.636719 28.074219 C 112.046875 27.886719 112.503906 27.820312 113.003906 27.878906 C 113.066406 28.898438 113 29.875 112.808594 30.816406 C 112.808594 29.902344 112.808594 28.988281 112.808594 28.074219 C 112.417969 28.074219 112.027344 28.074219 111.636719 28.074219 Z M 111.636719 28.074219 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.784314%,65.490196%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 12.96875 0.878906 C 16.402344 3.910156 20.234375 6.355469 24.472656 8.21875 C 28.082031 11.398438 28.703125 15.085938 26.324219 19.273438 C 25.660156 20.039062 24.914062 20.691406 24.082031 21.226562 C 24.574219 16.894531 22.753906 14.125 18.621094 12.914062 C 16.671875 12.832031 14.71875 12.734375 12.773438 12.621094 C 12.773438 12.292969 12.773438 11.96875 12.773438 11.640625 C 13.007812 8.378906 13.007812 5.117188 12.773438 1.859375 C 12.71875 1.484375 12.78125 1.15625 12.96875 0.878906 Z M 12.96875 0.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,20.784314%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 12.773438 11.640625 C 12.773438 11.96875 12.773438 12.292969 12.773438 12.621094 C 14.71875 12.734375 16.671875 12.832031 18.621094 12.914062 C 22.753906 14.125 24.574219 16.894531 24.082031 21.226562 C 23.996094 21.792969 23.800781 22.3125 23.496094 22.792969 C 21.160156 26.238281 18.042969 27.183594 14.136719 25.628906 C 12.324219 24.496094 11.152344 22.898438 10.628906 20.835938 C 9.46875 17.015625 7.78125 13.558594 5.558594 10.46875 C 6.507812 11.101562 7.546875 11.523438 8.675781 11.738281 C 9.953125 11.980469 11.21875 12.207031 12.480469 12.425781 C 12.519531 12.117188 12.617188 11.859375 12.773438 11.640625 Z M 12.773438 11.640625 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,5.098039%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 95.648438 13.988281 C 95.613281 18.164062 95.648438 22.335938 95.746094 26.511719 C 95.886719 26.40625 95.980469 26.273438 96.039062 26.121094 C 97.015625 24.191406 98.121094 22.332031 99.351562 20.542969 C 100.894531 20.507812 102.421875 20.410156 103.933594 20.25 C 104.066406 20.445312 104.066406 20.640625 103.933594 20.835938 C 102.402344 22.644531 100.9375 24.503906 99.546875 26.414062 C 101.238281 29.21875 102.925781 32.023438 104.617188 34.824219 C 104.585938 34.925781 104.550781 35.023438 104.519531 35.121094 C 102.9375 34.992188 101.347656 34.863281 99.742188 34.726562 C 98.75 32.804688 97.710938 30.914062 96.621094 29.054688 C 96.429688 29.34375 96.203125 29.605469 95.941406 29.835938 C 95.84375 31.53125 95.808594 33.226562 95.84375 34.925781 C 94.476562 34.925781 93.113281 34.925781 91.746094 34.925781 C 91.746094 27.945312 91.746094 20.96875 91.746094 13.988281 C 93.046875 13.988281 94.347656 13.988281 95.648438 13.988281 Z M 95.648438 13.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,5.098039%,32.156863%)",
      fillOpacity: 1
    },
    d: "M 33.832031 20.054688 C 35.945312 19.824219 37.539062 20.609375 38.609375 22.402344 C 39.847656 20.558594 41.570312 19.808594 43.777344 20.152344 C 45.753906 20.753906 46.890625 22.089844 47.191406 24.164062 C 47.289062 27.75 47.320312 31.335938 47.289062 34.925781 C 45.988281 34.925781 44.6875 34.925781 43.386719 34.925781 C 43.421875 31.792969 43.386719 28.664062 43.289062 25.53125 C 42.925781 23.488281 41.851562 22.964844 40.074219 23.96875 C 39.722656 24.285156 39.496094 24.679688 39.390625 25.140625 C 39.292969 28.402344 39.261719 31.664062 39.292969 34.925781 C 37.925781 34.925781 36.5625 34.925781 35.199219 34.925781 C 35.230469 31.597656 35.199219 28.269531 35.101562 24.945312 C 34.503906 23.359375 33.496094 23.03125 32.078125 23.96875 C 31.8125 24.265625 31.585938 24.59375 31.394531 24.945312 C 31.296875 28.269531 31.265625 31.597656 31.296875 34.925781 C 29.933594 34.925781 28.566406 34.925781 27.203125 34.925781 C 27.203125 30.097656 27.203125 25.273438 27.203125 20.445312 C 28.371094 20.445312 29.542969 20.445312 30.710938 20.445312 C 30.679688 21.035156 30.710938 21.625 30.808594 22.207031 C 31.582031 21.136719 32.589844 20.417969 33.832031 20.054688 Z M 33.832031 20.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,5.098039%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 53.136719 20.054688 C 55.652344 19.664062 57.765625 20.378906 59.476562 22.207031 C 59.851562 22.882812 60.109375 23.597656 60.253906 24.359375 C 60.320312 27.882812 60.417969 31.402344 60.546875 34.925781 C 59.3125 34.925781 58.078125 34.925781 56.84375 34.925781 C 56.875 34.460938 56.84375 34.007812 56.746094 33.554688 C 54.265625 35.902344 51.796875 35.902344 49.335938 33.554688 C 47.667969 29.832031 48.742188 27.253906 52.550781 25.824219 C 53.761719 25.457031 54.996094 25.292969 56.257812 25.335938 C 56.324219 23.675781 55.511719 22.894531 53.820312 22.988281 C 52.621094 23.097656 51.480469 23.421875 50.40625 23.96875 C 49.917969 23.117188 49.691406 22.203125 49.726562 21.226562 C 50.835938 20.695312 51.972656 20.300781 53.136719 20.054688 Z M 54.699219 28.074219 C 55.28125 28.074219 55.867188 28.074219 56.453125 28.074219 C 56.519531 29.136719 56.421875 30.183594 56.160156 31.207031 C 55.003906 32.546875 53.832031 32.613281 52.648438 31.402344 C 52.257812 29.613281 52.941406 28.503906 54.699219 28.074219 Z M 54.699219 28.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,5.098039%,32.156863%)",
      fillOpacity: 1
    },
    d: "M 69.710938 20.054688 C 73.539062 20.078125 75.457031 22.035156 75.464844 25.925781 C 75.5625 28.921875 75.59375 31.921875 75.5625 34.925781 C 74.199219 34.925781 72.832031 34.925781 71.46875 34.925781 C 71.5 31.921875 71.46875 28.921875 71.371094 25.925781 C 71.042969 23.523438 69.839844 22.902344 67.761719 24.066406 C 67.457031 24.515625 67.230469 25.003906 67.078125 25.53125 C 66.984375 28.664062 66.949219 31.792969 66.984375 34.925781 C 65.617188 34.925781 64.253906 34.925781 62.886719 34.925781 C 62.886719 30.097656 62.886719 25.273438 62.886719 20.445312 C 64.058594 20.445312 65.226562 20.445312 66.398438 20.445312 C 66.347656 20.996094 66.445312 21.519531 66.691406 22.011719 C 67.511719 21.03125 68.515625 20.378906 69.710938 20.054688 Z M 69.710938 20.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,5.098039%,32.156863%)",
      fillOpacity: 1
    },
    d: "M 116.902344 24.945312 C 116.902344 28.273438 116.902344 31.597656 116.902344 34.925781 C 115.734375 34.925781 114.5625 34.925781 113.390625 34.925781 C 113.355469 34.519531 113.257812 34.128906 113.101562 33.75 C 110.980469 35.609375 108.738281 35.773438 106.371094 34.238281 C 105.007812 32.664062 104.648438 30.867188 105.300781 28.859375 C 106.089844 27.351562 107.289062 26.339844 108.90625 25.824219 C 110.179688 25.445312 111.480469 25.28125 112.808594 25.335938 C 112.59375 23.335938 111.488281 22.585938 109.492188 23.085938 C 108.480469 23.285156 107.507812 23.578125 106.566406 23.96875 C 106.433594 23.140625 106.238281 22.324219 105.984375 21.523438 C 106.695312 20.871094 107.539062 20.480469 108.515625 20.347656 C 110.292969 19.914062 112.046875 19.976562 113.78125 20.542969 C 115.625 21.445312 116.667969 22.914062 116.902344 24.945312 Z M 111.636719 28.074219 C 112.027344 28.074219 112.417969 28.074219 112.808594 28.074219 C 112.808594 28.988281 112.808594 29.902344 112.808594 30.816406 C 112.128906 32.128906 111.085938 32.550781 109.6875 32.085938 C 108.777344 31.167969 108.679688 30.15625 109.394531 29.054688 C 110.039062 28.488281 110.785156 28.160156 111.636719 28.074219 Z M 111.636719 28.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,5.098039%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 77.707031 20.445312 C 79.105469 20.355469 80.472656 20.453125 81.800781 20.738281 C 81.535156 23.894531 81.566406 27.058594 81.898438 30.226562 C 82.589844 31.992188 83.730469 32.351562 85.3125 31.304688 C 85.5 31.027344 85.664062 30.734375 85.800781 30.425781 C 85.898438 27.097656 85.929688 23.773438 85.898438 20.445312 C 87.261719 20.445312 88.628906 20.445312 89.992188 20.445312 C 89.957031 25.273438 90.023438 30.101562 90.1875 34.925781 C 89.011719 34.988281 87.839844 34.921875 86.675781 34.726562 C 86.539062 34.28125 86.441406 33.828125 86.386719 33.359375 C 84.074219 35.695312 81.605469 35.890625 78.976562 33.945312 C 78.371094 33.128906 77.984375 32.214844 77.804688 31.207031 C 77.707031 27.621094 77.675781 24.03125 77.707031 20.445312 Z M 77.707031 20.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,5.490196%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 10.628906 20.835938 C 11.152344 22.898438 12.324219 24.496094 14.136719 25.628906 C 18.042969 27.183594 21.160156 26.238281 23.496094 22.792969 C 25.257812 27.570312 23.894531 31.125 19.402344 33.457031 C 17.582031 34.109375 15.761719 34.109375 13.941406 33.457031 C 11.023438 31.664062 8.03125 29.96875 4.972656 28.371094 C 3.367188 27.582031 1.675781 27.09375 -0.0976562 26.902344 C -0.0976562 26.773438 -0.0976562 26.640625 -0.0976562 26.511719 C 1.28125 26.453125 2.582031 26.09375 3.800781 25.433594 C 5.234375 24.585938 6.664062 23.738281 8.09375 22.890625 C 9.023438 22.296875 9.867188 21.613281 10.628906 20.835938 Z M 10.628906 20.835938 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManukaLogo);
export default __webpack_public_path__ + "static/media/Manuka-Logo.65602e313ff28f84969e6e625980c7d4.svg";
export { ForwardRef as ReactComponent };